import { formatVND } from "../../../constants"

const Item = ({ label, value, primary }) => (
  <div className={`prc-stat${primary ? " prc-stat--primary" : ""}`}>
    <span>{label}</span>
    <b>{value}</b>
  </div>
)

const PaymentSummary = ({ poTotal, previouslyPaid, remaining, payment, singleAmount }) => {
  if (singleAmount != null) {
    return (
      <div className="prc-summary" style={{ gridTemplateColumns: "1fr" }}>
        <Item label="Total Payment Amount" value={formatVND(singleAmount)} primary />
      </div>
    )
  }
  return (
    <div className="prc-summary">
      <Item label="Total PO Amount" value={formatVND(poTotal)} />
      <Item label="Previously Paid" value={formatVND(previouslyPaid)} />
      <Item label="Total Remaining" value={formatVND(remaining)} />
      <Item label="Total Payment Amount" value={formatVND(payment)} primary />
    </div>
  )
}

export default PaymentSummary
